import { u as p, f as d } from "../separate-component-helper-chunks/reactive-element-BDpydG15.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const l = { attribute: !0, type: String, converter: p, reflect: !1, hasChanged: d }, h = (e = l, n, t) => {
  const { kind: s, metadata: a } = t;
  let o = globalThis.litPropertyMetadata.get(a);
  if (o === void 0 && globalThis.litPropertyMetadata.set(a, o = /* @__PURE__ */ new Map()), o.set(t.name, e), s === "accessor") {
    const { name: r } = t;
    return { set(i) {
      const c = n.get.call(this);
      n.set.call(this, i), this.requestUpdate(r, c, e);
    }, init(i) {
      return i !== void 0 && this.P(r, void 0, e), i;
    } };
  }
  if (s === "setter") {
    const { name: r } = t;
    return function(i) {
      const c = this[r];
      n.call(this, i), this.requestUpdate(r, c, e);
    };
  }
  throw Error("Unsupported decorator location: " + s);
};
function y(e) {
  return (n, t) => typeof t == "object" ? h(e, n, t) : ((s, a, o) => {
    const r = a.hasOwnProperty(o);
    return a.constructor.createProperty(o, r ? { ...s, wrapped: !0 } : s), r ? Object.getOwnPropertyDescriptor(a, o) : void 0;
  })(e, n, t);
}
export {
  y as property,
  h as standardProperty
};
